// extracted by mini-css-extract-plugin
module.exports = {"product_list":"ListPage_product_list__1xE9r","page_header":"ListPage_page_header__1dre8"};